export class BaseModel {
  constructor(params: any) {
    Object.assign(this, params);
  }
}
